/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

export const API = {
  GENERIC: 'There has been a problem completing your request. Try again later.',
  NOT_PERMITTED: 'Not Permitted',
}
